<template>
<div>
    <v-container>
        <v-skeleton-loader :loading="loading" type="card-avatar, article">
            <v-card class="box-shadow-custom px-4">
                <Response :isShow="false" v-if="offers != ''" :offers="offers" :test="test" />
            </v-card>
        </v-skeleton-loader>
    </v-container>
    <Footer v-if="!loading" />
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from 'vuex'
import moment from 'moment'
export default {
    components: {
        Response: () => import('@/components/Response/Results'),
        Footer: () => import('@/components/Layout/Footer'),
    },
    data() {
        return {
            offers: [],
            test: '',
            loading: true
        }
    },
    computed: {
        ...mapGetters(['devices', 'snackbar'])
    },
    methods: {
        ...mapActions(['GetResponse']),
        ...mapMutations(['status_success', 'SnackbarSuccess']),
        dateTime(date) {
            return moment(date).format('MMMM Do YYYY h:mm a');
        },
        async response() {
            try {
                let url = `/internal/v2/link/${this.$route.params.id}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    let final_status = data.data.result.redirects.slice(-1)[0].status;
                    if (data.data.result.redirects.slice(-1)[0] != undefined) {
                        delete data.data.result.redirects.slice(-1)[0].time
                        this.offers = data.data.result.redirects
                    }
                    console.log(data)
                    this.test = {
                        test_url: data.data.result.test_url,
                        final_url: data.data.result.final_url,
                        os_device: data.data.result.platform,
                        os_version: data.data.result.os_ver,
                        hops: data.data.result.hops,
                        country: data.data.result.country,
                        total_ms: data.data.result.time_ms,
                        createdAt: data.data.result.test_time,
                        _id: data.data.result.id,
                        final_status: final_status
                    }
                    let dataMsg = {
                        success: true,
                        message: data.message,
                        action: 'success'
                    }
                    this.loading = false
                    this.SnackbarSuccess(dataMsg)
                } else {
                    let dataMsg = {
                        success: true,
                        message: data.message,
                        action: 'error'
                    }
                    this.loading = false
                    this.SnackbarSuccess(dataMsg)
                }
            } catch (error) {
                let dataMsg = {
                    success : !error.response.data.success,
                    message : error.response.data.errors[0].message,
                    action : 'error'
                }
                this.SnackbarSuccess(dataMsg)
                this.loading = false
            }
        }
    },
    async mounted() {
        await this.response()
    }
}
</script>
